<header class="topbar">
  <nav class="nav flex gap-3 ml-3 mt-3">
    <a routerLink="/">Home</a>
    <a routerLink="/login">Login</a>
    <a routerLink="/register">Register</a>
  </nav>
</header>

<main class="page-content">
  <router-outlet />
</main>
